import { renderField } from "../../../utils/formUtils";
import { useEffect, useState } from "react";
import { FaUserGraduate } from "react-icons/fa";
import defaultProfileImage from "../../../assets/image/profile_image.png";
import "./StudentForm.css";

const StudentDetailsSection = ({
  data,
  images,
  id,
  programData,
  handleImageChange,
  changeHandler,
  onFocusHandler,
  errors,
}) => {
  const [preview, setPreview] = useState({});
  let imageKey = "profile_image";
  const currentImage = images?.[imageKey];

  useEffect(() => {
    const imgObj = currentImage;

    if (imgObj?.file instanceof File) {
      const objectUrl = URL.createObjectURL(imgObj.file);
      setPreview((prev) => ({ ...prev, [imageKey]: objectUrl }));
      return () => URL.revokeObjectURL(objectUrl); // cleanup
    }

    if (imgObj?.preview) {
      setPreview((prev) => ({ ...prev, [imageKey]: imgObj.preview }));
    } else if (data?.[imageKey]) {
      setPreview((prev) => ({ ...prev, [imageKey]: data[imageKey] }));
    } else {
      setPreview((prev) => ({ ...prev, [imageKey]: defaultProfileImage }));
    }
  }, [currentImage, imageKey, data]); // ⚠️ use only the specific image object

  const studentFields = [
    {
      type: "file",
      label: "Profile Image",
      name: "profile_image",
      isFile: true,
      col: 10,
    },
    {
      type: "text",
      label: "Admission Number",
      name: "id_number",
      value: data.id_number,
      required: true,
      error: errors.id_number,
      disabled: !!id,
      col: 4,
    },
    {
      type: "text",
      label: "First Name",
      name: "first_name",
      value: data.first_name,
      required: true,
      error: errors.first_name,
      col: 4,
    },
    {
      type: "text",
      label: "Last Name",
      name: "last_name",
      value: data.last_name,
      error: errors.last_name,
      col: 4,
    },
    {
      type: "select",
      label: "Gender",
      name: "gender",
      value: data.gender,
      required: true,
      options: [
        { id: "male", name: "Male" },
        { id: "female", name: "Female" },
        { id: "transgender", name: "Transgender" },
      ],
      col: 4,
    },
    {
      type: "select",
      label: "Class",
      name: "program_id",
      value: data.program_id,
      required: true,
      options: programData,
      col: 4,
    },
    {
      type: "date",
      label: "DOB",
      name: "dob",
      value: data.dob,
      required: true,
      col: 4,
    },
    {
      type: "number",
      label: "Contact",
      name: "phone1",
      value: data.phone1,
      required: true,
      col: 4,
    },
    {
      type: "number",
      label: "Optional Contact",
      name: "phone2",
      value: data.phone2,
      col: 4,
    },
    {
      type: "text",
      label: "User Name",
      name: "user_name",
      value: data.user_name,
      required: true,
      col: 4,
    },
    {
      type: "email",
      label: "Email",
      name: "email",
      value: data.email,
      required: true,
      col: 4,
    },
    {
      type: "text",
      label: "Roll No",
      name: "roll_no",
      value: data.roll_no,
      col: 4,
    },
    {
      type: "text",
      label: "Category",
      name: "category",
      value: data.category,
      col: 4,
    },
    {
      type: "text",
      label: "Apaar ID",
      name: "apaar_id",
      value: data.apaar_id,
      col: 4,
    },
    {
      type: "text",
      label: "Aadhar Number",
      name: "aadhar_number",
      value: data.aadhar_number,
      maxLength: 12,
      minLength: 12,
      pattern: "\\d{12}",
      col: 4,
    },
    {
      type: "text",
      label: "House Name",
      name: "house_name",
      value: data.house_name,
      col: 4,
    },
    {
      type: "select",
      label: "Blood Group",
      name: "blood_group",
      value: data.blood_group,
      options: ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"].map((bg) => ({
        id: bg,
        name: bg,
      })),
      col: 4,
    },
    {
      type: "select",
      label: "Mode of Transport",
      name: "mode_of_transport",
      value: data.mode_of_transport,
      options: [
        { id: "self", name: "Self" },
        { id: "bus", name: "Bus" },
        { id: "van", name: "Van" },
      ],
      required: false,
      col: 4,
    },
    {
      type: "text",
      label: data.mode_of_transport === "bus" ? "Bus Route No.":"",
      name: "vehicle_number",
      value: data.vehicle_number,
      showIf:
        data.mode_of_transport === "bus",
      col: 4,
    },
    {
      type: "textarea",
      label: "Address",
      name: "address",
      value: data.address,
      rows: 3,
      col: 12,
    },
  ];

  return (
    <div className="card student-form-card student-form-card-indigo">
      <div className="student-form-card-header">
        <FaUserGraduate />
        <span>Student Details</span>
      </div>
      <div className="card-body row">
        <div className="col-md-2 student-form-avatar-wrap">
          <img
            src={preview[imageKey] || defaultProfileImage}
            alt="profile"
            className="student-form-avatar"
          />
        </div>
        {studentFields.map((field, idx) =>
          renderField(
            field,
            idx,
            handleImageChange,
            changeHandler,
            onFocusHandler,
            errors
          )
        )}
      </div>
    </div>
  );
};

export default StudentDetailsSection;
